import { render, staticRenderFns } from "./deficiencyTest.vue?vue&type=template&id=3528ffb0&scoped=true&"
import script from "./deficiencyTest.vue?vue&type=script&lang=js&"
export * from "./deficiencyTest.vue?vue&type=script&lang=js&"
import style0 from "./deficiencyTest.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./deficiencyTest.vue?vue&type=style&index=1&id=3528ffb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528ffb0",
  null
  
)

export default component.exports